import { render, staticRenderFns } from "./WaitingRoom-comp.vue?vue&type=template&id=32354926&scoped=true&"
import script from "./WaitingRoom-comp.vue?vue&type=script&lang=js&"
export * from "./WaitingRoom-comp.vue?vue&type=script&lang=js&"
import style0 from "./WaitingRoom-comp.vue?vue&type=style&index=0&id=32354926&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32354926",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VIcon})
